import { render, staticRenderFns } from "./TableColumnStatus.vue?vue&type=template&id=6f15a8ed&functional=true&"
import script from "./TableColumnStatus.vue?vue&type=script&lang=js&"
export * from "./TableColumnStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports